import { render, staticRenderFns } from "./MenuContabilidad.vue?vue&type=template&id=559aa863&scoped=true&"
import script from "./MenuContabilidad.vue?vue&type=script&lang=js&"
export * from "./MenuContabilidad.vue?vue&type=script&lang=js&"
import style0 from "./MenuContabilidad.vue?vue&type=style&index=0&id=559aa863&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559aa863",
  null
  
)

export default component.exports